import { State } from "./state";
import { storeInit } from "../../../Store";
const initialRtc: State.Data = {
  tcr: 0,
  cir: 0,
};

export const initial: State.Props = storeInit(initialRtc);
export default initial;
